module.exports = __webpack_public_path__ + "img/storage.60cdce3f.svg";